import {OnDestroy, Pipe, PipeTransform} from '@angular/core';
import {ISponsor} from '@api/models/sponsor/sponsor';
import {AdCampaignService} from '@components/ad-campaign/services/ad-campaign.service';
import {Subscription} from 'rxjs';

@Pipe({
  name: 'showAdBanner'
})
export class ShowAdBannerPipe implements PipeTransform, OnDestroy {

  private readonly campaign$: Subscription;

  constructor( private adCampaignService: AdCampaignService ) {
    if (this.campaign$) {
      return;
    }
    this.campaign$ = this.adCampaignService.campaignChange.subscribe(() => this.transform());
  }

  public transform(sponsors?: ISponsor[]): boolean {
    const hasCampaign = this.adCampaignService.campaign?.length > 0 && this.adCampaignService.showCampaign;
    const hasSponsors = sponsors?.length > 0;
    return hasCampaign || (hasSponsors && !this.adCampaignService.campaign?.length);
  }

  public ngOnDestroy(): void {
    this.campaign$?.unsubscribe();
  }

}
